var map = {
	"./Abarrotes.png": 3505,
	"./Broasteria.png": 1885,
	"./Carniceria.png": 6283,
	"./Empresa.png": 7447,
	"./Fabrica.png": 4698,
	"./Feria.png": 7087,
	"./Hotel.png": 5240,
	"./Kiosco.png": 8888,
	"./Mayorista.png": 8207,
	"./Puesto movil.png": 4231,
	"./Restaurante.png": 7556,
	"./Tienda.png": 8581,
	"./avatar.png": 4211,
	"./barrelOil.png": 6354,
	"./box.png": 2233,
	"./chica.png": 4372,
	"./chico.png": 4730,
	"./deuda.png": 9629,
	"./fullLogo.png": 790,
	"./imgDefault.jpg": 7952,
	"./journal-text.svg": 3901,
	"./location_back.png": 6595,
	"./location_danger.png": 6631,
	"./location_info.png": 8434,
	"./location_success.png": 5373,
	"./location_warning.png": 6488,
	"./logo.png": 3153,
	"./logoImage.png": 5026,
	"./logoImageBack.png": 4519,
	"./logoWhite.png": 8314,
	"./money.webp": 8922,
	"./note.png": 6504,
	"./oil.png": 5006,
	"./profile.png": 7653,
	"./soyasariBackground.png": 7439,
	"./soyasariBackgroundBack.jpg": 506,
	"./store.png": 389,
	"./texture.png": 7763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;